import type { Components, Theme } from '@mui/material';

export const chipCustomizations: Components<Theme> = {
  MuiChip: {
    styleOverrides: {
      root: {
        fontWeight: 500,
      },
      colorSuccess: {
        backgroundColor: '#D1FAE5', // Light green background
        color: '#065F46', // Darker green text
        '& .MuiChip-icon': {
          color: '#065F46',
        },
      },
      colorError: {
        backgroundColor: '#FEE2E2', // Light red background
        color: '#991B1B', // Darker red text
        '& .MuiChip-icon': {
          color: '#991B1B',
        },
      },
      colorInfo: {
        backgroundColor: '#DBEAFE', // Light blue background
        color: '#1E40AF', // Darker blue text
        '& .MuiChip-icon': {
          color: '#1E40AF',
        },
      },
      colorWarning: {
        backgroundColor: '#FEF3C7', // Light yellow background
        color: '#92400E', // Darker yellow text
        '& .MuiChip-icon': {
          color: '#92400E',
        },
      },
      colorDefault: {
        backgroundColor: '#F3F4F6', // Light gray background
        color: '#374151', // Darker gray text
        '& .MuiChip-icon': {
          color: '#374151',
        },
      },
    },
  },
};
